import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmNotEnoughBalanceError } from '@/core/error/transport/customErrors/tmNotEnoughBalanceError'

export const notEnoughBalanceErrorRule: CustomErrorRule = {
  subCodes: ['balance.insufficient_funds'],
  klass: TmNotEnoughBalanceError,
}
